<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12">
        <p class="gray--text mb-5 list-modality__title">
          SEGURADORA: {{ insurance.nome }}
        </p>
        <p class="font-weight-bold primary--text mb-2">
          SUB-MODALIDADE {{ subModality.nome }}
        </p>
      </v-col>
      <v-col cols="6" class="pb-5">
        <v-switch
          v-model="editForm.possui_api"
          class="pa-0 ma-0 justify-self-center d-inline-block insurance-step-modality__switch"
          inset
          dense
          hide-details
          color="secondary"
        />
        <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
          Possui API
        </p>
      </v-col>
      <v-col cols="6" class="pb-5">
        <v-switch
          v-model="editForm.ativo"
          class="pa-0 ma-0 justify-self-center d-inline-block insurance-step-modality__switch"
          inset
          dense
          hide-details
          color="secondary"
        />
        <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
          {{ isActivate }}
        </p>
      </v-col>
      <v-col cols="12">
        <p class="font-weight-regular mb-2 primary--text">
          Prazo estimado em dias
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <BaseFormInput
          id-element="draftContractSubModalityInsurance"
          placeholder="Inserir"
          v-model="editForm.prazo_minuta_dias"
          required
          :rules="[requiredInput]"
          label-text="Minuta"
          :disabled="editForm.possui_api"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseFormInput
          id-element="policyContractSubModalityInsurance"
          placeholder="Inserir"
          v-model="editForm.prazo_apolice_dias"
          required
          :rules="[requiredInput]"
          label-text="Apólice"
          :disabled="editForm.possui_api"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <BaseMoney
          id-element="valueSubModalityInsurance"
          placeholder="Inserir"
          v-model="editForm.valor_emissao_sem_ccg"
          required
          :rules="[requiredInput]"
          label-text="Emissão s/CCG"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseFormSelect
          id-element="paymentSubModalityInsurance"
          placeholder="Inserir"
          v-model="editForm.forma_pagamento"
          required
          :rules="[requiredInput]"
          label-text="Forma de Pagamento (Padrão)"
          :items="listPaymentMethods"
          item-text="nome"
          item-value="id"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" class="pb-8 pt-5">
        <v-divider />
      </v-col>
      <v-col cols="12">
        <p class="font-weight-bold mb-5 primary--text">
          DISCLAIMER
        </p>
      </v-col>
      <v-col cols="12" class="pb-12">
        <BaseFormTextArea
          id-element="disclaimerSubModalityInsurance"
          placeholder="Inserir texto"
          v-model="editForm.texto_disclaimer"
          label-text="Texto de observação sobre documentos"
        />
      </v-col>
    </v-row>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" class="pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR'"
            class="white--text pink"
            width="100%"
            @click="openModalCancel"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3">
          <BaseButton
            v-html="'SALVAR'"
            class="white--text secondary"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </BaseFooter>
    <ModalCancelModality
      @close="closeModalCancel"
      v-model="modalCancelModality"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </v-form>
</template>
<script>
import { requiredInput } from "@/utils/rules.js";
import { InsuranceCompanyMixin } from "@/mixins/NewInsuranceCompanyMixin";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import ModalCancelModality from "../../insurance_company/components/ModalCancelInsurance";
import _ from "lodash";
export default {
  data: () => ({
    requiredInput,
    modalCancelModality: false,
    editForm: {}
  }),
  mixins: [LoadingRequest, InsuranceCompanyMixin],
  components: {
    ModalCancelModality
  },
  created() {
    this.editForm = _.cloneDeep(this.form);
    this.fetchPayment();
  },
  computed: {
    ...mapState("insuranceCompany", ["listPaymentMethods"]),
    editModality() {
      return {
        name: "insurance_company edit modality",
        step: 2
      };
    },
    listSubModality() {
      return {
        name: "insurance_company select sub modality",
        step: 2
      };
    },
    isActivate() {
      return this.editForm.ativo ? "Ativo" : "Inativo";
    }
  },
  methods: {
    ...mapActions("insuranceCompany", ["requestPaymentMethods"]),
    fetchPayment() {
      this.withLoading(this.requestPaymentMethods());
    },
    previousStep() {
      this.$emit(
        "updateStep",
        this.payloadInsuranceCompany(this.form, this.editModality)
      );
    },
    submit() {
      if (this.$refs.form.validate())
        if (!this.editForm.submodalidade)
          this.editForm.submodalidade = _.cloneDeep(this.subModality);
      this.$emit(
        "updateSubModality",
        this.payloadInsuranceCompany(this.editForm, this.editModality)
      );
    },
    openModalCancel() {
      this.modalCancelModality = true;
    },
    closeModalCancel(value) {
      this.cancel = value;
      this.modalCancelModality = false;
      if (value) {
        this.previousStep();
      } else {
        this.$emit("setReturnFalse");
      }
    }
  },
  props: {
    return: {
      type: Boolean
    },
    insurance: {
      type: Object
    },
    subModality: {
      type: Object
    },
    form: {
      type: Object
    }
  },
  watch: {
    return(value) {
      value && this.openModalCancel();
    },
    "editForm.possui_api"(value) {
      // Vou precisar do texto por conta da ordenação
      // da tabela, pois mesmo que eu troque os valores
      // de true e false para sim e não, ainda terei
      // problemas na ordenação, pois false vem antes
      // que true, ficando invertido a ordenação
      // Por hora, fica no front isso (não sei
      // se terá envio de informações para o back)
      this.editForm.api = value ? "Sim" : "Não";
      if (value) {
        this.editForm.prazo_minuta_dias = "0";
        this.editForm.prazo_apolice_dias = "0";
      }
    }
  }
};
</script>
